import type { ReactNode } from 'react';

import { Navigate } from 'react-router';

import { hasRoles } from '../utils';
import { useAuthContext } from '../hooks';
import { Role } from '../../enums/auth/role.enum';

export type RoleBasedGuardProp = {
  allowedRoles: Role[];
  children: ReactNode;
  redirectPath?: string;
};

export function RoleBasedGuard({
  allowedRoles,
  children,
  redirectPath = '/dashboard',
}: Readonly<RoleBasedGuardProp>) {
  if (!allowedRoles || allowedRoles.length === 0) {
    throw new Error('RoleBasedGuard: allowedRoles prop is required');
  }

  const { user, assumedRoleId } = useAuthContext();

  const currentRoles: Role[] = user?.authorities || [];
  if (assumedRoleId) {
    currentRoles.push(Role.Admin);
  }

  if (hasRoles(currentRoles, allowedRoles)) {
    return <> {children} </>;
  }

  return <Navigate to={redirectPath} replace />;
}
